export const genericError = {
  success: false,
  title: 'Something went wrong!',
  message: 'There a problem with your request, please try again shortly.',
};

export const genericSuccess = {
  success: true,
  title: 'Success!',
  message: 'Your changes have been made!',
};

export const emailError = {
  success: false,
  title: 'Something went wrong!',
  message: 'Please make sure you the email address you entered is valid.',
};

export const captchaError = {
  success: false,
  title: 'Oops!',
  message: 'Please solve the captcha before submitting your request.',
};

export const gdprError = {
  success: false,
  title: 'Oops!',
  message:
    'Please make sure all checkboxes are selected before submitting your request.',
};

export const submitSuccess = {
  success: true,
  title: 'Success!',
  message: 'Your request has been submitted!',
};

export const badgeNameError = {
  success: false,
  title: 'Oops!',
  message: 'Please make sure all badges have a title.',
};

export const badgeLogoError = {
  success: false,
  title: 'Oops!',
  message: 'Please make sure all badges have an image uploaded.',
};

export const getListedError = {
  success: true,
  persist: true,
  title: 'It looks like you may already have a PartnerPage account!',
  setLink: function foo(link) {
    this.message = `<a style="color: #4d48e8; text-decoration: underline;" href="${link}">Click here</a> to login to your account and edit your profile`;
  },
  message: `<a style="color: #4d48e8; text-decoration: underline;" href="${process.env.VUE_APP_PROTOCOL_PREFIX}://${process.env.VUE_APP_ADMIN_SUBDOMAIN}.${process.env.VUE_APP_ROOT_CLIENT}">Click here</a> to login to your account and edit your profile`,
};

export const inviteSuccess = {
  success: true,
  title: 'Success!',
  message: 'Your invitation was sent.',
};

export const invitationDeleteSuccess = {
  success: true,
  title: 'Success!',
  message: 'Your invitation was deleted successfully.',
};

export const formError = {
  success: false,
  title: 'Oops!',
  message: 'Please make sure all required fields are filled out.',
};
